// import date from '@/components/kit/date'

export default function(ctx, inject) {
  const apiAaltra = {
    alertConfiguration: () => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/alert-configuration/get

      return ctx.$axiosAaltra.$get('alertsettings')
    },
    updateAlertConfiguration: (configurationAppliances) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/alert-configuration/put

      return ctx.$axiosAaltra.$put('alertsettings', {
        settings: configurationAppliances
      })
    },
    alerts: (applianceId, continuationToken) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/alerts/get

      return ctx.$axiosAaltra.$get('alerts', {
        params: {
          applianceId: applianceId || null,
          continuation: continuationToken || null
        }
      })
    },
    applianceTypes: () => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/appliance-type/get
      return ctx.$axiosAaltra.$get(`appliancetypes`, {})
    },
    updateAplianceType: (applianceType) => {
      return ctx.$axiosAaltra
        .$put(`appliancetypes/${applianceType.id}`, applianceType)
        .catch((err) => err)
    },
    applianceDetails: (id, format, interval, startTime, timezoneOffset) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/appliance-details/get
      // format = energy || currency
      // interval = days || weeks || months || years
      // startTime = start date in seconds from epoch
      // timezoneOffset = timezone offset of start date

      return ctx.$axiosAaltra.$get(`appliances/${id}`, {
        params: {
          format,
          interval,
          startTime,
          timezoneOffset
        }
      })
    },
    applianceLiveData: (id) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/appliance-live-data/get

      return ctx.$axiosAaltra.$get(`appliances/${id}/live`)
    },
    applianceLogs: (applianceId, continuationToken) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/appliance-logs/get

      return ctx.$axiosAaltra.$get('appliances/logs', {
        params: {
          applianceId: applianceId || null,
          continuation: continuationToken || null
        }
      })
    },
    auth: (token, isAccessToken) => {
      return ctx.$axiosAaltra.$post('auth', isAccessToken, {
        headers: {
          Authorization: token ? `Bearer ${token}` : ''
        }
      })
    },
    history: (format, interval, startTime, timezoneOffset) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/history/get
      // format = energy || currency
      // interval = days || weeks || months || years
      // startTime = start date in seconds from epoch
      // timezoneOffset = timezone offset of start date

      return ctx.$axiosAaltra.$get('history', {
        params: {
          format,
          interval,
          startTime,
          timezoneOffset
        }
      })
    },
    home: (format, interval) => {
      const date = new Date(Date.now())
      date.setHours(0, 0, 0, 0)

      switch (interval) {
        case 'week': {
          // getMonday
          const day = date.getDay()
          const difference = date.getDate() - day + (day === 0 ? -6 : 1)
          date.setDate(difference)
          break
        }
        case 'month':
          date.setDate(1)
          break
        case 'year':
          date.setDate(1) // first day of the month - 1-based
          date.setMonth(0) // first month of the year - 0-based
          break
      }

      const startTime = date.getTime() / 1000
      const timezoneOffset = date.getTimezoneOffset()

      // https://daikinhemsapi.docs.apiary.io/#reference/0/home/get
      // format = energy || currency
      // interval = day || week || month || year
      // startTime = start date in seconds from epoch
      // timezoneOffset = timezone offset of start date
      return ctx.$axiosAaltra.$get('', {
        params: {
          format,
          interval,
          startTime,
          timezoneOffset
        }
      })
    },
    forecast: (format, interval) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/forecast/get
      // format = energy || currency
      // interval = months || years

      return ctx.$axiosAaltra.$get('forecast', { params: { format, interval } })
    },
    forecastHistory: (format, interval) => {
      // format = energy || currency
      // interval = months || years
      return ctx.$axiosAaltra.$get('forecast/history', {
        params: { format, interval }
      })
    },
    liveData: () => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/live-data/get

      return ctx.$axiosAaltra.$get('live')
    },
    settingsEnergyBudget: () => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/settings-energy-budget/get

      // yearlyUsage || yearlyCost will be filled out
      // numberOfPeople filled out when heatPumpConsumptionIncluded = false

      return ctx.$axiosAaltra.$get('settings/energybudget')
    },
    updateSettingsEnergyBudget: (settings) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/settings-energy-budget/put
      // yearlyUsage || yearlyCost will be filled out
      // numberOfPeople filled out when heatPumpConsumptionIncluded = false

      return ctx.$axiosAaltra
        .$put('settings/energybudget', settings)
        .catch((err) => err)
    },
    settingsEnergyTariff: () => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/settings-energy-tariff/get

      return ctx.$axiosAaltra.$get('settings/tariffSettings')
    },
    updateSettingsEnergyTariff: (settings) => {
      // https://daikinhemsapi.docs.apiary.io/#reference/0/settings-energy-tariff/put

      return ctx.$axiosAaltra
        .$put('settings/tariffSettings', settings)
        .catch((err) => err)
    },
    settingsSolar: () => {
      return ctx.$axiosAaltra.$get('settings/solar')
    },
    updateSettingsSolar: (settings) => {
      return ctx.$axiosAaltra
        .$put('settings/solar', settings)
        .catch((err) => err)
    },
    settingsPvOptimisation: () => {
      return ctx.$axiosAaltra.$get('settings/pv-optimisation')
    },
    settingsBudgetControl: () => {
      return ctx.$axiosAaltra.$get('settings/budget-control')
    },
    updateSettingsPvOptimisation: (settings) => {
      return ctx.$axiosAaltra.$put('settings/pv-optimisation', settings)
    },
    updateSettingsEnergySaving: (settings) => {
      return ctx.$axiosAaltra.$put('settings/budget-control', settings)
    },
    deleteOnectaToken: () => {
      return ctx.$axiosAaltra.$delete('settings/onecta-token')
    }
  }

  ctx.$apiAaltra = apiAaltra
  inject('apiAaltra', apiAaltra)
}
